import axios from 'axios';

export const getExternalKey = () =>
  axios.post('/user/v1/auth/guest-sign-in', undefined, { headers: { Authorization: 'No-Need-Authorization' } });
export const getProviderDetail = id => axios.get(`/appointment/v1/providers/${id}`);
